<div class="refering-vets-section">
  <h3>{{ 'popup.share_study_by_refering_vet.title' | translate }}</h3>
  <p class="description">{{ 'popup.share_study_by_refering_vet.description' | translate }}</p>

  <app-autocomplete-selector
    [label]="'popup.share_study_by_refering_vet.select' | translate"
    [filter]="onFilterReferingVets"
    [resetAfterSelected]="true"
    (selectItemChanged)="onSelectedVetChanged($event)">
  </app-autocomplete-selector>
</div>

<mat-card #vetListCard class="targets" *ngIf="selectedReferingVets.length > 0">
  <mat-card-header>
    <mat-card-title>{{ 'popup.share_study_by_refering_vet.selected' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="vet-list">
      <div class="vet-item" *ngFor="let vet of selectedReferingVets">
        <div class="vet-details">
          <div class="line-1">
            <strong>{{ vet.lastName }} {{ vet.firstName }}</strong>
            <span class="separator">-</span>
            <span class="email">{{ vet.email }}</span>
          </div>
          <div class="line-2">
            <span class="clinic" *ngIf="vet.clinicName">{{ vet.clinicName }}</span>
            <span class="separator" *ngIf="vet.clinicName && vet.city">,</span>
            <span class="location" *ngIf="vet.city">{{ vet.postalCode }} {{ vet.city }}</span>
          </div>
        </div>
        <button class="delete-button" mat-mini-fab color="accent"
          [matTooltip]="'popup.share_study_by_refering_vet.delete_tooltip' | translate"
          (click)="deleteReferingVetById(vet.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
